import { useRef, useState } from "react";
import './SlideToStop.css';
import SlideButton from "../../assets/slide_button.svg";
import Spinner from "../../Components/Spinner";

const THUMB_SIZE = 52;
const CONFIRM_THRESHOLD = 0.7;

export default function SlideToStop({ label, confirmingLabel, confirming, onConfirm }:
    { label: string, confirmingLabel: string, confirming: boolean, onConfirm: () => void }) {

    const trackRef = useRef<HTMLDivElement>(null);
    const [offset, setOffset] = useState(0);
    const [dragging, setDragging] = useState(false);
    const dragStartRef = useRef(0);

    function getMaxOffset() {
        const track = trackRef.current;
        return track ? track.clientWidth - THUMB_SIZE - 8 : 0;
    }

    function handlePointerDown(e: React.PointerEvent) {
        if (confirming) return;
        setDragging(true);
        dragStartRef.current = e.clientX + offset;
        (e.currentTarget as Element).setPointerCapture(e.pointerId);
    }

    function handlePointerMove(e: React.PointerEvent) {
        if (!dragging) return;
        const max = getMaxOffset();
        const raw = dragStartRef.current - e.clientX;
        setOffset(Math.max(0, Math.min(max, raw)));
    }

    function handlePointerUp() {
        if (!dragging) return;
        setDragging(false);
        const max = getMaxOffset();
        if (max > 0 && offset >= max * CONFIRM_THRESHOLD) {
            setOffset(max);
            onConfirm();
        } else {
            setOffset(0);
        }
    }

    const displayOffset = confirming ? getMaxOffset() : offset;

    return (
        <div className={"slide-to-stop" + (confirming ? " slide-to-stop--confirming" : "")} ref={trackRef}>
            <span className="slide-to-stop-target"/>
            <span className="slide-to-stop-label">{confirming ? confirmingLabel : label}</span>
            <div
                className="slide-to-stop-thumb"
                style={{
                    transform: `translateX(-${displayOffset}px)`,
                    transition: dragging ? "none" : "transform 0.25s ease-out"
                }}
                onPointerDown={handlePointerDown}
                onPointerMove={handlePointerMove}
                onPointerUp={handlePointerUp}
                onPointerCancel={handlePointerUp}
            >
                {confirming ? (
                    <div className="slide-to-stop-spinner-thumb">
                        <Spinner size={22} strokeWidth={2.5} color="#fff" label="Stopper" />
                    </div>
                ) : (
                    <img src={SlideButton} alt="" draggable={false}/>
                )}
            </div>
        </div>
    );
}
